import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { Timeline } from '../models/timeline.model';
import { TimelineSummary } from '../models/timeline-summary.model';
import { resumeCatchUpOf } from '../utils/catch-up-wait';

// [#1300] The resume's catch-up as its Seller sees it - null when the engagement has none running. Read for the
// catch-up banner only; the drill-down keeps its own timeline.
export const GetResumeCatchUp = createAsyncThunk(
    'engagements/GetResumeCatchUp',
    async (engagementId: number, dispatch: any): Promise<Timeline | null> => {
        const axios = dispatch.getState().core.axios;
        try {
            const timelines = await axios.get(`/api/Marketplace/Engagements/${engagementId}/timelines`);
            const catchUp = resumeCatchUpOf(timelines.data as TimelineSummary[]);
            if (!catchUp) {
                return null;
            }

            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/timelines/${catchUp.timelineId}`
            );
            return response.data;
        } catch (error) {
            createNotification('An error occurred while loading the catch-up.', 'error');
            throw error;
        }
    }
);
